(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kaos-audio-categories"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.kac').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';
    const track = section.querySelector('[data-kac-track]');
    const previous = section.querySelector('[data-kac-previous]');
    const next = section.querySelector('[data-kac-next]');
    if (!track) return;
    const scrollByCard = (direction) => {
      const card = track.querySelector('.kac__card');
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };
    previous?.addEventListener('click', () => scrollByCard(-1));
    next?.addEventListener('click', () => scrollByCard(1));
  });

  } catch(e) { console.error(e); }
})();
})();
